import * as React from 'react';
import { MenuEntry } from '@europrocurement/flexy-components';

import PrescriberDetail from './views/detail/PrescriberDetail';
import PrescripteursListing from './views/listing/PrescripteursListing';
import PrescripteurAdd from './views/create/PrescripteurCreation';
import PrescipteurRoot from './views/PrescripteurRoot';
import { PRESCRIBER_LIST, prescripteursBasePath /** , PRESCRIBER_NEW */ } from './constants/paths';

export const PrescripteurRouter = {
    path: prescripteursBasePath,
    element: <PrescipteurRoot />,
    handle: { title: 'Prescripteurs' },
    children: [
        {
            path: 'liste',
            children: [
                {
                    path: '',
                    index: true,
                    element: <PrescripteursListing />,
                    handle: { title: 'Prescripteurs - Liste' },
                },
                {
                    path: ':idPrescripteur',
                    element: <PrescriberDetail />,
                    handle: { title: 'Prescripteurs - Détails' },
                },
            ],
        },
        {
            path: 'new',
            element: <PrescripteurAdd />,
            handle: { title: 'Prescripteurs - Création' },
        },
    ],
};

export const PrescripteurMenuEntries: MenuEntry[] = [
    {
        title: 'Prescripteurs',
        icon: 'fa-buildings',
        role: 'prescripteur',
        children: [
            {
                title: 'Liste des prescripteurs',
                icon: 'fa-building-magnifying-glass',
                href: PRESCRIBER_LIST,
                role: 'prescripteur',
            },
            // {
            //     title: 'Nouveau prescripteur',
            //     icon: 'fa-building-circle-arrow-right',
            //     href: PRESCRIBER_NEW,
            //     role: 'prescripteur',
            // },
        ],
    },
];
